/**
 * Check for subscriptions variable and display accordingly
 */
function checkAndDisplaySubscriptions() {
  // Use URLSearchParams to get the URL parameters
  var urlParams = new URLSearchParams(window.location.search);

  // Check if 'enable_subscriptions' URL parameter exists
  if (urlParams.has("enable_subscriptions")) {
    var elements = document.getElementsByClassName("subscriptions_wrapper");
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.display = "block";
    }
  }
}

function insertCustomCheckmarkHTML() {
    var checkboxes = $(".shopify_subscriptions_app_block_purchase_options > .shopify_subscriptions_app_block_label label input");

    checkboxes.each(function(index, element) {
        $('<span class="checkmark"></span>').insertAfter(element);
    });
}

document.addEventListener("DOMContentLoaded", function() {
  checkAndDisplaySubscriptions();
  insertCustomCheckmarkHTML()
});


/**
 * Subscriptions radio overrides
 */
$(document).ready(function() {

    function addRevealReplies() {
        $('.merchant-reply').each(function () {
            let reply = $(this);
            if (!reply.prev().hasClass('reveal-replies')) {
                let toggleLink = $('<a href="#" class="reveal-replies">Show Replies</a>');

                // Insert the link before the reply
                reply.before(toggleLink);

                // Hide the reply initially
                reply.hide();
            }
        });
    }

    // Delegated event listener to handle clicks on dynamically added elements
    $(document).on('click', '.reveal-replies', function (e) {
        e.preventDefault();
        let reply = $(this).next('.merchant-reply');
        reply.toggle();
        $(this).text(reply.is(':visible') ? 'Hide Replies' : 'Show Replies');
        $(this).toggleClass('open');        
    });

    // Run initially in case reviews are already present
    addRevealReplies();

    // Observe the entire body for added elements
    const observer = new MutationObserver(() => {
        addRevealReplies();
    });

    observer.observe(document.body, { childList: true, subtree: true });


  $('.single-option-selector').on('change', function(e) {
      $('.shopify_subscriptions_app_block_container .shopify_subscriptions_app_block_purchase_options>.shopify_subscriptions_app_block_label:first-child label input').each(function(e) {
          $(this).click();
      });
  });


  $(".shopify_subscriptions_app_block_label_children").each(function() {
    var $container = $(this);
    var $radioList = $container.find("ul");

    // Hide the radio buttons
    $radioList.hide();

    // Create the select element
    var $select = $('<select class="selling-plan-select"></select>');
    $container.append($select);

    // Populate the select element with options based on the radio buttons
    $radioList.find('input[type="radio"]').each(function() {
      var $radio = $(this);
      var label = $radio
        .parent()
        .text()
        .trim();

      label = label.split(",")[0];
      //label = label.replace("Delivery every", "");

      var option = $("<option>")
        .val($radio.data("selling-plan-id"))
        .text(label)
        .data("selling-plan-group-id", $radio.data("selling-plan-group-id"))
        .data("selling-plan-id", $radio.data("selling-plan-id"))
        .data("selling-plan-adjustment", $radio.data("selling-plan-adjustment"))
        .data("radio-type", $radio.data("radio-type"));
      $select.append(option);
    });

    // Update the hidden radio buttons when the select element is changed
    $select.change(function() {
      var selectedOption = $(this).find("option:selected");
      var selectedValue = selectedOption.val();
      var singlePurchaseRadio = $(
        ".shopify_subscriptions_app_block_purchase_options > .shopify_subscriptions_app_block_label:first-child > label input",
      );
      var subscriptionPurchaseRadio = $(
        ".shopify_subscriptions_app_block_purchase_options > .shopify_subscriptions_app_block_label:last-child > label input",
      );

      singlePurchaseRadio.prop("checked", false);
      subscriptionPurchaseRadio.prop("checked", true);

      $radioList.find('input[type="radio"]').each(function() {
        if ($(this).data("selling-plan-id") == selectedValue) {
          //$(this).prop("checked", true);
          $(this).click();
        } else {
          //$(this).prop("checked", false);
        }
      });
    });

    // Trigger change event to set the initial state
    //$select.trigger("change");
  });
});
